import * as React from 'react';

import * as style from './Main.css';

export const Main: React.FC<React.PropsWithChildren<{}>> = props => {
  const { children } = props;

  return <main className={style['container']}>{children}</main>;
};
